import { cn } from '@/ui/utils/classnames';
import ChainItem from './parts/chain-item.js';
import type { MenuChain } from './types.js';

export interface ChainMenuProps {
  chains: MenuChain[];
  className?: string;
}

function ChainMenu({ chains, className }: ChainMenuProps) {
  return (
    <ul className={cn('flex flex-col', className)}>
      {chains.map(({ name, address }) => (
        <li key={name}>
          <ChainItem name={name} address={address} />
        </li>
      ))}
    </ul>
  );
}

export default ChainMenu;
